import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import instance from "@src/api/axiosInstance";
import { message } from 'antd';
import { noop } from 'lodash';

interface DeletePromptInput {
  id: number;
}

interface DeletePromptResponse {
  success: boolean;
}

const deletePrompt = async (input: DeletePromptInput): Promise<DeletePromptResponse> => {
  const url = `/nexa/system-prompt/${input.id}`;
  const response = await instance.delete(url);
  return response.data;
};

export function useDeletePrompt({ onDone = noop }): UseMutationResult<
  DeletePromptResponse,
  unknown,
  DeletePromptInput
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletePrompt,
    onSuccess: () => {
      message.info('Prompt deleted successfully');
      queryClient.invalidateQueries(['system-prompts']);
      onDone();
    },
  });
}
